var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{staticClass:"top-bar",attrs:{"elevation":8}},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }